import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/setting/admin/`;

const getAdmins = async () => {
    return await axios.get(API_URL);
};

const getAvailableUsers = async () => {
    return await axios.get(`${API_URL}available-users`);
};

const getAdmin = async (id) => {
    return await axios.get(API_URL + id);
};

const addAdmin = async (adminData) => {
    return await axios.post(API_URL, adminData);
};

const editAdmin = async (adminId, updatedData) => {
    return await axios.put(API_URL + adminId, updatedData);
};

const deleteAdmin = async (adminId) => {
    return await axios.delete(API_URL + adminId);
};

export default {
    getAdmins,
    getAvailableUsers,
    getAdmin,
    addAdmin,
    editAdmin,
    deleteAdmin
};

